import Experiments from '@wix/wix-experiments';

const config = {
  baseUrl: 'https://www.wix.com',
};

export const getVODExperiments = () => {
  if (window.__EXPERIMENTS__) {
    return window.__EXPERIMENTS__;
  }
  const service = new Experiments(config);
  return service.load('vod').then(() => service.all());
};
